import {
  Component, EventEmitter, OnInit, Output, ChangeDetectorRef, ViewChild, ViewContainerRef
} from '@angular/core';
import { AppService } from '../services/app.service';

interface MenuItem {
  MenuId: string,
  MenuPid: string,
  MenuTitle: string,
  MenuLink: string,
  MenuIcon?: string,
  Open: boolean,
  SubMenu?: MenuItem[]
}

@Component({
  //changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css']
})
export class SidebarComponent implements OnInit {
  @Output() CurrentPath = new EventEmitter<string>();
  @ViewChild('sidebar', { read: ViewContainerRef }) vc: ViewContainerRef;
  //@ViewChild('tpl', { read: TemplateRef }) tpl: TemplateRef<any>;

  ContentPrinted: boolean = false;
  Controller: string = 'Users';
  NavigatorData: any[];
  Menu: any[];

  constructor(private AppService: AppService, private ChangeDetector: ChangeDetectorRef) {
  }

  ngOnInit() {
    this.AppService.currentMenu.subscribe(fMenu => {
      if (fMenu) {
        this.Menu = fMenu;
        const element = { MenuId: '0' }; // this.Menu.filter(x => { return x.MenuId === '0'; });
        this.ProcessMenu(element, this.Menu);
      }

      this.ContentPrinted = false;    // control execute function menuEventHandler flag
      if (this.ChangeDetector.detectChanges) {
        this.ChangeDetector.detectChanges();  // check menu tree is changed
      }
    });
  }

  ngAfterContentInit(): void {
    // Content has been initialized!
  }

  ngAfterViewInit(): void {
    // View has been initialized!
  }

  ngAfterViewChecked(): void {
    // View has been checked!
  }

  MenuEventHandler() {
    this.ContentPrinted = true;
    this.ChangeDetector.detectChanges();
    // handle navigator items event
    const NavItems = document.querySelectorAll('#sidebarnav > li > a');

    for (let index = 0; index < NavItems.length; index++) {
      const element: Element = NavItems[index];
      // add click event listener to html tag A
      element.addEventListener('click', function () {
      });
    }
    // handle navigator items event -- end
  }

  GetFolderIcon(currItem: MenuItem) {
    let icon = currItem.Open ? 'fa-folder' : 'fa-folder-open';
    return 'fas ' + icon;
  }

  folderClick(currItem: MenuItem) {
    currItem.Open = !currItem.Open;
  }

  ChangeParentPath(evt: any) {
    // Sidebar navigation click event
  }

  ProcessMenu(element: any, Menu: any) {
    if (Menu) {
      let tempMenu = Menu;
      let tempCate = tempMenu.filter(x => {
        return x.MenuPid === element.MenuId;
      });
      if (element.MenuId === "40") {
        console.log('t');
      }
      let newMenu = tempCate.map(x => {
        let item: MenuItem = {
          MenuId: x.MenuId,
          MenuPid: x.MenuPid,
          MenuTitle: x.MenuTitle,
          MenuLink: x.MenuLink,
          Open: false,
          MenuIcon: x.MenuIcon !== '' ? x.MenuIcon : 'far fa-file',
          SubMenu: new Array<MenuItem>()
        };
        return item;
      });

      // distinct
      var flags = [], unique: MenuItem[] = new Array<MenuItem>(), l = newMenu.length, i: number;
      for (i = 0; i < l; i++) {
        if (flags[newMenu[i].MenuId]) continue;
        flags[newMenu[i].MenuId] = true;
        unique.push(newMenu[i]);
      }

      if (element.MenuId === '0') {
        this.NavigatorData = unique;
      } else {
        if (element.SubMenu && element.SubMenu.length > 0) {
          element.SubMenu.push(unique);
        } else {
          element.SubMenu = unique;
        }
      }
      newMenu.forEach(element => {
        this.ProcessMenu(element, Menu);
      });
    }
  }
}
